import { CustomButton } from 'modules/auth/styles'
import { getContents_action, getDrafts_action, getPrivateAndFavoriteContents_action, getRecentlyVeiwedContent_action, toggleDeleteContentModal_action, getTotalItemsCount_action } from 'store/actions'
import { deleteContent_api } from 'store/apis'
import { useState } from 'react'
import { connect } from 'react-redux'
import { Modal, ModalBody } from 'reactstrap'
import { history } from 'store/store'
import { ButtonLoader } from 'utils/storageUtils'
import { generateSlug, handleApiError, logAmplitudeEvent } from 'utils/helpers'
import { toast } from 'react-toastify'

function DeleteContentConfirmModal(props) {
  const [isDeleting, set_isDeleting] = useState(false)
  const onDelete = async () => {
    try {
      set_isDeleting(true)
      let newContent = {}
      const { deletingContent } = props.contents
      await deleteContent_api(deletingContent.id)
      props.getTotalItemsCount()
      if (deletingContent.type === 'page' && !deletingContent.is_draft) {
        props.getDrafts()
      }
      if (deletingContent.is_draft) {
        props.getDrafts()
      } else if (deletingContent.category?.uuid) {
        props.getContents({ type: deletingContent.type, category_uuid: deletingContent.category?.uuid })
      } else {
        props.getPrivateAndFavoriteContents({ type: deletingContent.type })
      }
      set_isDeleting(false)
      toast.success(`Item ${deletingContent.type === 'page' && !deletingContent.is_draft ? 'unpublished' : 'deleted'}`)
      props.toggleDeleteContentModal(false)
      props.getRecentlyVeiwedContent() /** to remove Getting started boxes in homepage */
      if (deletingContent.type === 'page' && deletingContent.is_draft) {
        logAmplitudeEvent('Deleted a draft')
      }
      if (newContent.id && newContent.type === 'page') {
        history.push(`/pages/drafts/edit/${generateSlug(newContent)}`)
      } else if (props.contents.redirectToHome) {
        history.push('/')
      }
    } catch (error) {
      handleApiError(error)
      set_isDeleting(false)
    }
  }
  return (
    <Modal zIndex={props.fullScreenStatus ? '300000000000' : ''} centered fade={false} size='sm' isOpen={props.contents.showDeleteContentConfirm} toggle={() => props.toggleDeleteContentModal(false)}>
      <ModalBody className='pt-5 pb-4'>
        <div className='text-center text-danger'>
          <strong>
            Are you sure you want to {props.contents.deletingContent.type === 'page' && !props.contents.deletingContent.is_draft ? 'unpublish' : 'delete'} this {props.contents.deletingContent.type}?
          </strong>
        </div>
        <div className='mt-4 d-flex justify-content-center align-items-center'>
          <CustomButton onClick={onDelete} className='btn-sm black mx-3' disabled={isDeleting}>
            Yes, {props.contents.deletingContent.type === 'page' && !props.contents.deletingContent.is_draft ? 'unpublish' : 'delete'}
            {isDeleting && <ButtonLoader />}
          </CustomButton>
          <a
            href='/'
            className='mx-3 text-dark'
            onClick={(e) => {
              e.preventDefault()
              props.toggleDeleteContentModal(false)
            }}>
            Cancel
          </a>
        </div>
      </ModalBody>
    </Modal>
  )
}

const mapStateToProps = (state) => ({
  contents: state.contents,
  fullScreenStatus: state.contents.isFullScreen
})

const mapDispatchToProps = (dispatch) => ({
  getContents: (filters) => dispatch(getContents_action(filters)),
  getPrivateAndFavoriteContents: (filters) => dispatch(getPrivateAndFavoriteContents_action(filters)),
  getRecentlyVeiwedContent: () => dispatch(getRecentlyVeiwedContent_action()),
  getDrafts: () => dispatch(getDrafts_action()),
  toggleDeleteContentModal: (status, item, redirectToHome) => dispatch(toggleDeleteContentModal_action(status, item, redirectToHome)),
  getTotalItemsCount: () => dispatch(getTotalItemsCount_action())
})
export default connect(mapStateToProps, mapDispatchToProps)(DeleteContentConfirmModal)
